<div class="app-legend">

  <p>
    <svg width="20px" height="20px" opacity="0.7">
      <circle cy="10" cx="10" fill="#5cb85c" r="8" />
    </svg>
    <span i18n>OFFICE</span>
  </p>
  <p>
    <svg width="20px" height="20px" opacity="0.7">
      <circle cy="10" cx="10" fill="#f0ad4e" r="8" />
    </svg>
    <span i18n>CONNECTION</span>
  </p>
  <p>
    <svg width="20px" height="20px" opacity="0.7">
      <circle cy="10" cx="10" fill-opacity="0" stroke="#f0ad4e" stroke-width="2" r="8" />
    </svg>
    <span i18n>MANHOLE</span>
  </p>
  <p>
    <svg width="20px" height="20px" opacity="0.7">
      <circle cy="10" cx="10" fill="#3effe8" r="8" />
    </svg>
    <span i18n>POLE</span>
  </p>
  <p>
    <svg width="20px" height="20px" opacity="0.7">
      <circle cy="10" cx="10" fill-opacity="0" stroke="#3effe8" stroke-width="2" r="8" />
    </svg>
    <span i18n>POLE (END-OF-LINE)</span>
  </p>
  <p>
    <svg width="20px" height="20px" opacity="0.7">
      <circle cy="10" cx="10" fill="#ff0000" r="8" />
    </svg>
    <span i18n>POLE (ISOLATED)</span>
  </p>
  <p>
    <svg width="20px" height="20px" opacity="0.7">
      <line x1="0" y1="10" x2="20" y2="10" stroke="#3effe8" stroke-width="5" stroke-dasharray="8 4" />
    </svg>
    <span i18n>AERIAL CABLE</span>
  </p>
  <p>
    <svg width="20px" height="20px" opacity="0.7">
      <line x1="0" y1="10" x2="20" y2="10" stroke="#f0ad4e" stroke-width="5" stroke-dasharray="8 4" />
    </svg>
    <span i18n>UNDERGROUND CABLE</span>
  </p>
  <p>
    <svg width="20px" height="20px" opacity="0.7">
      <line x1="0" y1="10" x2="20" y2="10" stroke="#5cb85c" stroke-width="5" stroke-dasharray="8 4" />
    </svg>
    <span i18n>LATERAL CABLE</span>
  </p>
  <p>
    <svg width="20px" height="20px" opacity="0.7">
      <line x1="0" y1="10" x2="20" y2="10" stroke="#000000" stroke-width="20" />
    </svg>
    <span i18n>BUILDING</span>
  </p>
  <p>
    <svg width="20px" height="20px" opacity="0.7">
      <line x1="0" y1="10" x2="20" y2="10" stroke="#f0ad4e" stroke-width="20" />
    </svg>
    <span i18n>BUILDING (ZERO DEMAND)</span>
  </p>
  <p>
    <svg width="20px" height="20px" opacity="0.7">
      <line x1="0" y1="10" x2="20" y2="10" stroke="#ff0000" stroke-width="20" />
    </svg>
    <span i18n>BUILDING (DISCONNECTED)</span>
  </p>
  <p>
    <svg width="20px" height="20px" opacity="0.7">
      <line x1="0" y1="10" x2="20" y2="10" stroke="#29522f" stroke-width="20" />
    </svg>
    <span i18n>BUILDING (INDIVIDUAL)</span>
  </p>
  <p>
    <svg width="20px" height="20px" opacity="0.7">
      <line x1="0" y1="10" x2="20" y2="10" stroke="#805740" stroke-width="20" />
    </svg>
    <span i18n>BUILDING (COLLECTIVE HORIZONTAL)</span>
  </p>
  <p>
    <svg width="20px" height="20px" opacity="0.7">
      <line x1="0" y1="10" x2="20" y2="10" stroke="#6441b9" stroke-width="20" />
    </svg>
    <span i18n>BUILDING (COLLECTIVE VERTICAL)</span>
  </p>
  <p>
    <svg width="20px" height="20px" opacity="0.7">
      <circle cy="10" cx="10" fill="#fdca40" fill-opacity="6" r="4" />
    </svg>
    <span i18n>BUILDING-BORDER</span>
  </p>
  <p>
    <svg width="20px" height="20px" opacity="0.7">
      <line x1="0" y1="10" x2="20" y2="10" stroke="#C1AE9F" stroke-width="2" stroke-dasharray="6 4" />
    </svg>
    <span i18n>SQUARE</span>
  </p>

</div>
